import { render, staticRenderFns } from "./DialogLoading.vue?vue&type=template&id=36d14ca9&scoped=true&"
import script from "./DialogLoading.vue?vue&type=script&lang=js&"
export * from "./DialogLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d14ca9",
  null
  
)

export default component.exports